import React, { useState, useEffect } from 'react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Avatar } from '@mui/material';
import axios from 'axios';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode';
import Breadcumb from '../../Layouts/Breadcumb';
import DashboardNav from './DashboardNav';
import Swal from 'sweetalert2';
import { FaRegComments } from 'react-icons/fa';

const shakeStyle = `
@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
}
`;
const ChatInbox = () => {
  const [chatList, setChatList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showChatBox, setShowChatBox] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [chatMessage, setChatMessage] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const chatEndRef = React.useRef(null);
  const [messageError, setMessageError] = useState(false);
  const fileInputRef = React.useRef(null);

  useEffect(() => {
    fetchChatList(page);
  }, [page]);

  const fetchChatList = async (currentPage) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;
      const decoded = jwtDecode(token);

      const response = await axios.post(`${Constants.getChatListForProductOwner}`, {
        user_id: decoded.id,
        page: currentPage,
        limit,
      });

      if (response.data.status === 1) {
        setChatList(response.data.list);
      }
    } catch (error) {
      console.error('Error fetching chat list:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchChatHistory = async (product_id, buyer_id) => {
    try {
      const token = localStorage.getItem('authToken');
      const decoded = jwtDecode(token);
      const receiver_id = decoded.id;

      await axios.post(`${Constants.markMessagesSeen}`, { product_id, sender_id: buyer_id, receiver_id });

      const response = await axios.post(`${Constants.getMyChatHistory}`, { product_id, sender_id: buyer_id, receiver_id });

      if (response.data.status === 1) {
        const formatted = response.data.data.map(msg => ({
          text: msg.chat_msg,
          time: new Date(msg.created_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ", " +
            new Date(msg.created_time).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
          sender: msg.sender_id === buyer_id ? 'other' : 'me',
          image_url: msg.image_url || null
        }));
        setChatHistory(formatted);

        setChatList(prev => prev.map(chat =>
          chat.product_id === product_id && chat.buyer_id === buyer_id
            ? { ...chat, unread_count: 0 }
            : chat
        ));
      }
    } catch (error) {
      console.error('Error fetching chat history:', error);
    }
  };

  const handleSelectImage = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf"
    ];

    const allowedExtensions = ["png", "jpg", "jpeg", "pdf"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    // ❌ Type validation (strong check)
    if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Only PNG, JPG, JPEG and PDF files are allowed.",
        confirmButtonColor: "#B3902D"
      });

      e.target.value = "";
      return;
    }

    // ❌ Size validation (10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      Swal.fire({
        icon: "error",
        title: "File too large",
        text: "File size should not exceed 10MB.",
        confirmButtonColor: "#B3902D"
      });

      e.target.value = "";
      return;
    }

    // ✅ Keep your structure
    setSelectedImage({
      file,
      preview: URL.createObjectURL(file)
    });
  };

  // const handleSendMessage = async () => {
  //   if (!chatMessage.trim() && !selectedImage) {
  //     setMessageError(true);
  //     return;
  //   }

  //   setMessageError(false);
  //   try {
  //     const token = localStorage.getItem('authToken');
  //     const decoded = jwtDecode(token);
  //     const formData = new FormData();
  //     formData.append('sender_id', decoded.id);
  //     formData.append('receiver_id', selectedChat.buyer_id);
  //     formData.append('product_id', selectedChat.product_id);
  //     formData.append('msg', chatMessage);
  //     if (selectedImage?.file) formData.append('image', selectedImage.file);

  //     await axios.post(`${Constants.createChatMessage}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  //     setChatMessage('');
  //     setSelectedImage(null);
  //     fetchChatHistory(selectedChat.product_id, selectedChat.buyer_id);
  //   } catch (error) {
  //     console.error('Error sending message:', error);
  //   }
  // };

  const handleSendMessage = async () => {

    if (!chatMessage.trim()) {

      // retrigger shake animation
      setMessageError(false);

      setTimeout(() => {
        setMessageError(true);
      }, 10);

      return;
    }

    setMessageError(false);

    try {

      const token = localStorage.getItem('authToken');
      const decoded = jwtDecode(token);

      const formData = new FormData();

      formData.append('sender_id', decoded.id);
      formData.append('receiver_id', selectedChat.buyer_id);
      formData.append('product_id', selectedChat.product_id);
      formData.append('msg', chatMessage);

      if (selectedImage?.file) {
        formData.append('image', selectedImage.file);
      }

      await axios.post(
        `${Constants.createChatMessage}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setChatMessage('');
      setSelectedImage(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      fetchChatHistory(
        selectedChat.product_id,
        selectedChat.buyer_id
      );

    } catch (error) {
      console.error('Error sending message:', error);
    }
  };
  const handleDeleteChat = async (product_id, buyer_id) => {
    const token = localStorage.getItem('authToken');
    const decoded = jwtDecode(token);
    const owner_id = decoded.id;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#B3902D",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(`${Constants.deleteChat}`, {
            product_id,
            buyer_id,
            owner_id
          });

          if (response.data.status === 1) {
            Swal.fire("Deleted!", "Chat has been deleted.", "success");
            fetchChatList(page);
          } else {
            Swal.fire("Failed!", "Chat could not be deleted.", "error");
          }
        } catch (error) {
          console.error('Error deleting chat:', error);
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  // useEffect(() => {
  //   const chatBox = document.querySelector(".p-3.h-60.overflow-y-auto");
  //   if (chatBox) chatBox.scrollTop = chatBox.scrollHeight;
  // }, [chatHistory]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatHistory]);

  useEffect(() => {
    if (!selectedChat) return;

    const interval = setInterval(() => {
      fetchChatHistory(selectedChat.product_id, selectedChat.buyer_id);
    }, 5000); // every 5 seconds

    return () => clearInterval(interval);
  }, [selectedChat]);
  return (
    <>
      <style>{shakeStyle}</style>
      <Breadcumb pagetitle="Chat Inbox" />
      <section className="py-12 chatinboxpnel">
        <div className="container mx-auto px-4">
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}><DashboardNav /></Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              {isLoading ? <p>Loading chats...</p> : (
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto"
                  }}
                >
                  <TableContainer
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      background: "#fff"
                    }}
                  >
                    <Table
                      style={{
                        width: "100%",
                        minWidth: "700px",
                        borderCollapse: "collapse"
                      }}
                    >
                      <TableHead>
                        <TableRow
                          style={{
                            backgroundColor: "#fbf8f1"
                          }}
                        >
                          <TableCell style={{ fontWeight: "bold", color: "#232323" }}>
                            Product
                          </TableCell>

                          <TableCell style={{ fontWeight: "bold", color: "#232323" }}>
                            Buyer
                          </TableCell>

                          <TableCell style={{ fontWeight: "bold", color: "#232323" }}>
                            Last Message
                          </TableCell>

                          <TableCell style={{ fontWeight: "bold", color: "#232323" }}>
                            Unread
                          </TableCell>

                          <TableCell style={{ fontWeight: "bold", color: "#232323" }}>
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {chatList.map((chat, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px"
                                }}
                              >
                                {chat.product_imgUrl && (
                                  <Avatar src={chat.product_imgUrl} variant="square" />
                                )}
                                <span>{chat.product_name || "N/A"}</span>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px"
                                }}
                              >
                                {chat.buyer_image && <Avatar src={chat.buyer_image} />}
                                <span>{chat.buyer_name}</span>
                              </div>
                            </TableCell>

                            <TableCell
                              sx={{
                                whiteSpace: 'normal',
                                overflowWrap: 'anywhere',
                              }}
                            >
                              {chat.last_msg || "No message"}
                            </TableCell>

                            <TableCell>
                              {chat.unread_count > 0 ? (
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "2px 8px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#fff",
                                    backgroundColor: "#ef4444",
                                    borderRadius: "9999px"
                                  }}
                                >
                                  {chat.unread_count} Unread
                                </span>
                              ) : (
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "2px 8px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#9ca3af",
                                    backgroundColor: "#f3f4f6",
                                    borderRadius: "9999px"
                                  }}
                                >
                                  No Unread
                                </span>
                              )}
                            </TableCell>

                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "center"
                                }}
                              >
                                <button
                                  onClick={() => {
                                    setSelectedChat(chat);
                                    setShowChatBox(true);
                                    fetchChatHistory(chat.product_id, chat.buyer_id);
                                  }}
                                  style={{
                                    color: "#B3902D",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "18px"
                                  }}
                                >
                                  <i className="fa fa-comments"></i>
                                </button>

                                <button
                                  onClick={() =>
                                    handleDeleteChat(chat.product_id, chat.buyer_id)
                                  }
                                  style={{
                                    color: "#ef4444",
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "18px"
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </Grid>
          </Grid>

          {/* Chat Box */}
          {/* {showChatBox && selectedChat && (
            <div
              style={{
                position: "fixed",
                bottom: window.innerWidth < 640 ? "70px" : "20px", // push above mobile bottom
                right: window.innerWidth < 640 ? "10px" : "40px", // stay right side
                width: window.innerWidth < 640 ? "260px" : "288px", // smaller on mobile
                borderRadius: "6px",
                border: "1px solid #ddd",
                background: "#fff",
                zIndex: 999,
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
              }}
            >
              <div
                style={{
                  background: "#B3902D",
                  color: "#fff",
                  padding: "8px 16px",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: "600" }}>Chat</span>

                <button
                  onClick={() => setShowChatBox(false)}
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "20px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>

              <div
                style={{
                  padding: "12px",
                  height: "240px",
                  overflowY: "auto",
                }}
              >
                {chatHistory.map((msg, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      justifyContent: msg.sender === "me" ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "75%",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        background: msg.sender === "me" ? "#dbeafe" : "#fed7aa",
                      }}
                    >
                      {msg.image_url && (
                        <img
                          src={msg.image_url}
                          alt="Chat Image"
                          style={{
                            width: "128px",
                            height: "auto",
                            borderRadius: "6px",
                            marginBottom: "6px",
                          }}
                        />
                      )}

                      {msg.text && <div>{msg.text}</div>}

                      <div
                        style={{
                          fontSize: "10px",
                          color: "#6b7280",
                          marginTop: "4px",
                          textAlign: "right",
                        }}
                      >
                        {msg.time}
                      </div>
                    </div>
                  </div>
                ))}

                {selectedImage && (
                  <div
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "75%",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        background: "#dbeafe",
                      }}
                    >
                      <img
                        src={selectedImage.preview}
                        alt="Selected Preview"
                        style={{
                          width: "128px",
                          height: "auto",
                          borderRadius: "6px",
                          marginBottom: "6px",
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  borderTop: "1px solid #ddd",
                }}
              >
                <input
                  type="file"
                  onChange={handleSelectImage}
                  style={{ display: "none" }}
                  id="imageUpload"
                />

                <label
                  htmlFor="imageUpload"
                  style={{
                    background: "#B3902D",
                    color: "#fff",
                    padding: "0 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-paperclip" style={{ fontSize: "12px" }}></i>
                </label>

                <textarea
                  rows="1"
                  placeholder="Type your message here"
                  value={chatMessage}
                  onChange={(e) => setChatMessage(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                  style={{
                    flexGrow: 1,
                    padding: "8px",
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    resize: "none",
                  }}
                />

                <button
                  onClick={handleSendMessage}
                  style={{
                    background: "#000",
                    color: "#fff",
                    padding: "0 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-paper-plane" style={{ fontSize: "12px" }}></i>
                </button>
              </div>
            </div>
          )} */}

          {/* Chat Box */}
          {showChatBox && selectedChat && (
            <div
              style={{
                position: "fixed",
                bottom: window.innerWidth < 640 ? "70px" : "20px",
                right: window.innerWidth < 640 ? "10px" : "40px",
                width: window.innerWidth < 640 ? "260px" : "288px",
                borderRadius: "6px",
                border: "1px solid #ddd",
                background: "#fff",
                zIndex: 999,
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
              }}
            >
              <div
                style={{
                  background: "#B3902D",
                  color: "#fff",
                  padding: "8px 16px",
                  borderTopLeftRadius: "6px",
                  borderTopRightRadius: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: "600" }}>Chat</span>

                <button
                  onClick={() => setShowChatBox(false)}
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "20px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>

              <div
                style={{
                  padding: "12px",
                  height: "240px",
                  overflowY: "auto",
                }}
              >
                {chatHistory.map((msg, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "12px",
                      display: "flex",
                      justifyContent: msg.sender === "me" ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: "75%",
                        padding: "8px 12px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        background: msg.sender === "me" ? "#dbeafe" : "#fed7aa",

                        // ✅ FIX TEXT OVERFLOW
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere"
                      }}
                    >
                      {msg.image_url && (
                        <>
                          {msg.image_url.endsWith(".pdf") ? (
                            <a
                              href={msg.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                fontSize: "14px",
                                color: "#2563eb",
                                textDecoration: "none",
                                display: "block",
                                marginBottom: "6px"
                              }}
                            >
                              📄 Open PDF
                            </a>
                          ) : (
                            <img
                              src={msg.image_url}
                              alt="Chat"
                              style={{
                                width: "128px",
                                borderRadius: "6px",
                                marginBottom: "6px",
                              }}
                            />
                          )}
                        </>
                      )}

                      {msg.text && <div>{msg.text}</div>}

                      <div
                        style={{
                          fontSize: "10px",
                          color: "#6b7280",
                          marginTop: "4px",
                          textAlign: "right",
                        }}
                      >
                        {msg.time}
                      </div>
                    </div>
                  </div>
                ))}
                <div ref={chatEndRef} />
              </div>

              {/* ✅ IMAGE PREVIEW MOVED HERE */}
              {selectedImage && (
                <div
                  style={{
                    padding: "8px",
                    borderTop: "1px solid #ddd",
                    position: "relative"
                  }}
                >
                  <button
                    onClick={() => {
                      setSelectedImage(null);

                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                    style={{
                      position: "absolute",
                      top: "4px",
                      right: "4px",
                      background: "transparent",
                      border: "none",
                      color: "red",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "500",
                      padding: 0,
                      lineHeight: 1
                    }}
                  >
                    ✕
                  </button>

                  {selectedImage.file &&
                    selectedImage.file.type === "application/pdf" ? (
                    <div style={{ fontSize: "12px" }}>
                      📄 {selectedImage.file.name}
                    </div>
                  ) : (
                    selectedImage.preview && (
                      <img
                        src={selectedImage.preview}
                        alt="Preview"
                        style={{
                          width: "80px",
                          borderRadius: "6px"
                        }}
                      />
                    )
                  )}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  borderTop: "1px solid #ddd",
                }}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".png,.jpg,.jpeg,.pdf"
                  onChange={handleSelectImage}
                  style={{ display: "none" }}
                  id="imageUpload"
                />

                <label
                  htmlFor="imageUpload"
                  style={{
                    background: "#B3902D",
                    color: "#fff",
                    padding: "0 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-paperclip" style={{ fontSize: "12px" }}></i>
                </label>

                {/* <textarea
                  rows="1"
                  placeholder="Type your message here"
                  value={chatMessage}
                  onChange={(e) => {
                    setChatMessage(e.target.value);

                    if (e.target.value.trim()) {
                      setMessageError(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                  style={{
                    flexGrow: 1,
                    padding: "8px",
                    border: messageError ? "1px solid red" : "none",
                    outline: "none",
                    fontSize: "14px",
                    resize: "none",
                    animation: messageError ? "shake 0.3s" : "none"
                  }}
                /> */}

                <textarea
                  rows="1"
                  placeholder="Type your message here"
                  value={chatMessage}
                  onChange={(e) => {
                    setChatMessage(e.target.value);

                    if (e.target.value.trim()) {
                      setMessageError(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                  style={{
                    flexGrow: 1,
                    padding: "8px",
                    border: "1px solid",
                    borderColor: messageError ? "red" : "transparent",
                    outline: "none",
                    fontSize: "14px",
                    resize: "none",
                    transition: "border-color 0.2s ease",
                    animation: messageError ? "shake 0.3s" : ""
                  }}
                />

                <button
                  onClick={handleSendMessage}
                  style={{
                    background: "#000",
                    color: "#fff",
                    padding: "0 12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-paper-plane" style={{ fontSize: "12px" }}></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ChatInbox;
